// extracted by mini-css-extract-plugin
export var actions = "Cubewise-module--actions--a7385";
export var atTopPage = "Cubewise-module--atTopPage--feb38";
export var ctaSection = "Cubewise-module--ctaSection--ea544";
export var extendedMenuSection = "Cubewise-module--extendedMenuSection--8ef4b";
export var globalSearch = "Cubewise-module--globalSearch--3d7d4";
export var languageSwitcher = "Cubewise-module--languageSwitcher--25d88";
export var logoSection = "Cubewise-module--logoSection--de59e";
export var mobileCascadeMenu = "Cubewise-module--mobileCascadeMenu--0e11e";
export var mobileCascadeMenuHolder = "Cubewise-module--mobileCascadeMenuHolder--cbb32";
export var mobileMenu = "Cubewise-module--mobileMenu--cbfd7";
export var scrolling = "Cubewise-module--scrolling--8c296";
export var tkAktivGrotesk = "Cubewise-module--tk-aktiv-grotesk--09bf7";
export var tkAktivGroteskCondensed = "Cubewise-module--tk-aktiv-grotesk-condensed--7f465";
export var tkAktivGroteskExtended = "Cubewise-module--tk-aktiv-grotesk-extended--30958";
export var tkAktivGroteskThin = "Cubewise-module--tk-aktiv-grotesk-thin--21ec8";
export var tkNeuzeitGrotesk = "Cubewise-module--tk-neuzeit-grotesk--6cb4e";
export var tkNeuzeitGroteskCondensed = "Cubewise-module--tk-neuzeit-grotesk-condensed--6add6";
export var tkNeuzeitGroteskExtraConden = "Cubewise-module--tk-neuzeit-grotesk-extra-conden--9ac37";
export var topMenuSection = "Cubewise-module--topMenuSection--21788";
export var wrapper = "Cubewise-module--wrapper--e67cc";